import React from 'react';
import { PDFViewer } from '@react-pdf/renderer';
import FileManager from './FileManager';

const Home = () => {
 
  return (
    <div>
      <div id="main">
    <div>
      <FileManager></FileManager>
    </div>
  </div>

    </div>
  );
};

export default Home;
